const DeprecatedComponent = () => {
  return <div style={{ display: 'none' }} />
}

DeprecatedComponent.displayName = 'DeprecatedComponent'

export default DeprecatedComponent
